import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { TemplateEntityType } from '@tribeplatform/gql-client/types';
import { useTemplates } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { SpinnerIcon } from '@tribeplatform/react-ui-kit/icons';
import { Modal } from '@tribeplatform/react-ui-kit/Modal';
import { T, useI18n } from '../../i18n';
import { CreateSpaceTemplate } from '../CreateSpaceTemplate';
import { TemplateCard } from './TemplateCard';
export const isMasterNetwork = id => {
    return id === 'ITjYLMTebn';
};
const templatesOrder = [
    'Discussions',
    'Questions',
    'Guidelines',
    'Landing page',
    'Ideas',
    'Articles',
    'Events',
    'Product updates',
    'Changelogs',
    'Job board',
    'Blank page',
];
export const TemplateSelectionModal = ({ open, onClose, onSelect, }) => {
    const intl = useI18n();
    const { data, isLoading, error } = useTemplates({
        fields: {
            image: 'basic',
            requiredTemplates: 'basic',
        },
        variables: {
            entityTypes: [TemplateEntityType.Space],
            limit: 100,
        },
    });
    const { nodes: templates } = simplifyPaginatedResult(data);
    const [createTemplateModal, setCreateTemplateModal] = useState(null);
    const fallback = (_jsx(Button, { variant: "primary", fullWidth: true, onClick: () => onSelect(null), children: _jsx(T, { id: "Space.TemplateSelectionModal.FallbackButtonText", defaultMessage: "Continue without template" }, void 0) }, void 0));
    return (_jsxs(_Fragment, { children: [_jsxs(Modal, { open: open, onClose: onClose, size: "3xl", children: [_jsx(Modal.Header, { title: intl.$t({
                            id: 'Space.TemplateSelectionModal.HeaderTitle',
                            defaultMessage: 'Choose a starter template',
                        }), description: intl.$t({
                            id: 'Space.TemplateSelectionModal.Description',
                            defaultMessage: 'You can fully customize your blocks and layout after choosing a template',
                        }) }, void 0), _jsx(Modal.Content, { children: _jsxs("div", { className: "flex flex-col space-y-5", children: [isLoading && (_jsx("div", { className: "flex items-center justify-center h-32\t", children: _jsx(SpinnerIcon, { className: "animate-spin" }, void 0) }, void 0)), _jsxs("div", { className: "grid grid-cols-2 sm:grid-cols-3 gap-4", children: [templates === null || templates === void 0 ? void 0 : templates.sort((a, b) => {
                                            if (templatesOrder.indexOf(a.name) === -1) {
                                                return 100;
                                            }
                                            return (templatesOrder.indexOf(a === null || a === void 0 ? void 0 : a.name) -
                                                templatesOrder.indexOf(b === null || b === void 0 ? void 0 : b.name));
                                        }).map(template => {
                                            if (['crm', 'Private Message'].indexOf(template.name) !== -1) {
                                                return null;
                                            }
                                            return (_jsx(TemplateCard, { template: template, onSelect: onSelect, onUpdateTemplate: setCreateTemplateModal }, template === null || template === void 0 ? void 0 : template.id));
                                        }), !isLoading && templates.length === 0 && (_jsxs("div", { className: "space-y-3", children: [_jsx("div", { children: _jsx(T, { id: "Space.TemplateSelectionModal.NotFoundText", defaultMessage: "No templates found" }, void 0) }, void 0), fallback] }, void 0)), !isLoading && error && (_jsxs("div", { className: "space-y-3", children: [_jsx("div", { children: _jsx(T, { id: "Space.TemplateSelectionModal.LoadFailedText", defaultMessage: "Could not load templates" }, void 0) }, void 0), fallback] }, void 0))] }, void 0)] }, void 0) }, void 0)] }, void 0), createTemplateModal && (_jsx(CreateSpaceTemplate, { template: createTemplateModal, open: true, onClose: () => setCreateTemplateModal(null) }, void 0))] }, void 0));
};
//# sourceMappingURL=TemplateSelectionModal.js.map